/* bundle-widget.js */
/* Save this file in: assets/bundle-widget.js */

(function() {
    class BundleWidget {
      constructor() {
        this.init();
      }
  
      init() {
        document.querySelectorAll('.bundle-widget').forEach(widget => {
          if (widget.dataset.initialized) return;
          widget.dataset.initialized = 'true';
          this.setupWidget(widget);
        });
      }
  
      setupWidget(widget) {
        const options = widget.querySelectorAll('.bundle-option');
        const addToCartBtn = widget.querySelector('[data-action="add-to-cart"]');
        const buyNowBtn = widget.querySelector('[data-action="buy-now"]');
        let selectedOption = widget.querySelector('.bundle-option.selected') || options[0];
  
        // If no option is selected, select the first one
        if (!selectedOption && options.length > 0) {
          selectedOption = options[0];
          selectedOption.classList.add('selected');
        }
  
        // Handle option selection
        options.forEach(option => {
          option.addEventListener('click', () => {
            options.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
            selectedOption = option;
          });
        });
  
        // Add to Cart
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', async () => {
            const currentSelected = widget.querySelector('.bundle-option.selected');
            if (!currentSelected) return;
            await this.handleAddToCart(widget, currentSelected, addToCartBtn);
          });
        }

        // Buy Now
        if (buyNowBtn) {
          buyNowBtn.addEventListener('click', async () => {
            const currentSelected = widget.querySelector('.bundle-option.selected');
            if (!currentSelected) return;
            await this.handleBuyNow(widget, currentSelected, buyNowBtn);
          });
        }
      }
  
      async handleAddToCart(widget, selectedOption, button) {
        const variantId = selectedOption.dataset.variant;
        const quantity = parseInt(selectedOption.dataset.quantity);
        const includeGift = selectedOption.dataset.includeGift === 'true';
        const freeGiftVariantId = widget.dataset.freeGiftVariant;
  
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding...';
  
        try {
          const itemsToAdd = [{
            id: variantId,
            quantity: quantity
          }];
  
          if (includeGift && freeGiftVariantId) {
            itemsToAdd.push({
              id: freeGiftVariantId,
              quantity: 1,
              properties: {
                '_gift': 'true',
                '_gift_with_purchase': 'Do not remove - Free with bundle'
              }
            });
          }
  
          const cartNotification = document.querySelector('cart-notification');
          const cartItems = document.querySelector('cart-items');
  
          const formData = new FormData();
          
          itemsToAdd.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
            
            if (item.properties) {
              Object.keys(item.properties).forEach(key => {
                formData.append(`items[${index}][properties][${key}]`, item.properties[key]);
              });
            }
          });
  
          if (cartNotification) {
            const sections = cartNotification.getSectionsToRender().map(section => section.id);
            formData.append('sections', sections);
          }
          formData.append('sections_url', window.location.pathname);
  
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
  
          if (!response.ok) throw new Error('Failed to add to cart');
  
          const parsedState = await response.json();
  
          if (parsedState.status) {
            this.showNotification('Error: ' + parsedState.description, true);
            return;
          }
  
          const message = includeGift && freeGiftVariantId
            ? `Added ${quantity} item(s) + FREE gift to cart! 🎉`
            : `Added ${quantity} item(s) to cart! 🎉`;
  
          this.showNotification(message);
  
          if (cartNotification) {
            cartNotification.renderContents(parsedState);
          }
          if (cartItems) {
            cartItems.renderContents(parsedState);
          }
  
        } catch (error) {
          console.error('Bundle Widget Error:', error);
          this.showNotification('Error adding to cart. Please try again.', true);
        } finally {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
  
      async handleBuyNow(widget, selectedOption, button) {
        const variantId = selectedOption.dataset.variant;
        const quantity = parseInt(selectedOption.dataset.quantity);
        const includeGift = selectedOption.dataset.includeGift === 'true';
        const freeGiftVariantId = widget.dataset.freeGiftVariant;
  
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Processing...';
  
        try {
          await fetch('/cart/clear.js', { method: 'POST' });
  
          const itemsToAdd = [{
            id: variantId,
            quantity: quantity
          }];
  
          if (includeGift && freeGiftVariantId) {
            itemsToAdd.push({
              id: freeGiftVariantId,
              quantity: 1,
              properties: {
                '_gift': 'true',
                '_gift_with_purchase': 'Do not remove - Free with bundle'
              }
            });
          }
  
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          });
  
          window.location.href = '/checkout';
  
        } catch (error) {
          console.error('Bundle Widget Error:', error);
          this.showNotification('Error processing purchase. Please try again.', true);
          button.disabled = false;
          button.textContent = originalText;
        }
      }
  
      showNotification(message, isError = false) {
        const notification = document.createElement('div');
        notification.className = 'bundle-notification' + (isError ? ' error' : '');
        notification.textContent = message;
        document.body.appendChild(notification);
  
        setTimeout(() => {
          notification.style.animation = 'bundleSlideOut 0.3s ease-out';
          setTimeout(() => notification.remove(), 300);
        }, 3000);
      }
    }
  
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new BundleWidget());
    } else {
      new BundleWidget();
    }
  
    // Re-initialize when Shopify section is reloaded (for theme editor)
    document.addEventListener('shopify:section:load', () => new BundleWidget());
  })();